import { useQuery } from 'data-fetching-client';
import * as React from 'react';
import NoIdDefaultLabel from 'flow-doctor-lib/components/common/NoIdDefaultLabel';
import SkeletonText from 'flow-doctor-lib/components/common/SkeletonText';
import { CRM_SEARCH_BY_ID_FIELD_NAME, GET_CRM_SEARCH_OBJECT_BY_ID } from 'flow-doctor-lib/queries/CrmObjectQueries';
import { getIdentifierPropertyForObject } from 'flow-doctor-lib/utils/objectUtils';
import { GET_OBJECT_TYPE_DEFINITION } from 'flow-doctor-lib/queries/ObjectDefinitionQueries';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ObjectNameLabel = ({
  portalId,
  objectTypeId,
  objectId,
  showId = false
}) => {
  var _data$CRM_SEARCH_BY_I;
  const {
    loading,
    error,
    data
  } = useQuery(GET_CRM_SEARCH_OBJECT_BY_ID, {
    variables: {
      portalId: Number(portalId),
      objectTypeId,
      objectId: objectId.toString()
    }
  });
  const {
    data: objectDefData
  } = useQuery(GET_OBJECT_TYPE_DEFINITION, {
    variables: {
      objectTypeId,
      portalId
    }
  });
  if (error) {
    return /*#__PURE__*/_jsx(NoIdDefaultLabel, {
      objectId: objectId
    });
  }
  if (loading || !data) {
    return /*#__PURE__*/_jsx(SkeletonText, {});
  }
  const objectResponse = (_data$CRM_SEARCH_BY_I = data[CRM_SEARCH_BY_ID_FIELD_NAME]) === null || _data$CRM_SEARCH_BY_I === void 0 || (_data$CRM_SEARCH_BY_I = _data$CRM_SEARCH_BY_I.results) === null || _data$CRM_SEARCH_BY_I === void 0 ? void 0 : _data$CRM_SEARCH_BY_I[0];
  const objectLabel = objectResponse ? getIdentifierPropertyForObject(objectResponse, objectDefData && objectDefData.objectTypeDefinition) : null;
  if (!objectLabel) {
    return /*#__PURE__*/_jsx(NoIdDefaultLabel, {
      objectId: objectId
    });
  }
  return /*#__PURE__*/_jsx("span", {
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [objectLabel, ' ', showId && /*#__PURE__*/_jsx(NoIdDefaultLabel, {
        objectId: objectId,
        parenthesize: true
      })]
    })
  });
};
export default ObjectNameLabel;